import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=41dd2871&scoped=true"
import script from "./CourseEdit.vue?vue&type=script&lang=js"
export * from "./CourseEdit.vue?vue&type=script&lang=js"
import style0 from "./CourseEdit.vue?vue&type=style&index=0&id=41dd2871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dd2871",
  null
  
)

export default component.exports